import { render, staticRenderFns } from "./VideoPlayerPoster.vue?vue&type=template&id=28e54deb&scoped=true&"
import script from "./VideoPlayerPoster.vue?vue&type=script&lang=ts&"
export * from "./VideoPlayerPoster.vue?vue&type=script&lang=ts&"
import style0 from "./VideoPlayerPoster.vue?vue&type=style&index=0&id=28e54deb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e54deb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
